/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface DocumentAdminDetail
 */
export interface DocumentAdminDetail {
  /**
   *
   * @type {number}
   * @memberof DocumentAdminDetail
   */
  readonly id: number
  /**
   *
   * @type {string}
   * @memberof DocumentAdminDetail
   */
  slug?: string | null
  /**
   *
   * @type {string}
   * @memberof DocumentAdminDetail
   */
  name?: string | null
  /**
   *
   * @type {string}
   * @memberof DocumentAdminDetail
   */
  text?: string | null
}

/**
 * Check if a given object implements the DocumentAdminDetail interface.
 */
export function instanceOfDocumentAdminDetail(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'id' in value

  return isInstance
}

export function DocumentAdminDetailFromJSON(json: any): DocumentAdminDetail {
  return DocumentAdminDetailFromJSONTyped(json, false)
}

export function DocumentAdminDetailFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): DocumentAdminDetail {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: json['id'],
    slug: !exists(json, 'slug') ? undefined : json['slug'],
    name: !exists(json, 'name') ? undefined : json['name'],
    text: !exists(json, 'text') ? undefined : json['text'],
  }
}

export function DocumentAdminDetailToJSON(value?: DocumentAdminDetail | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    slug: value.slug,
    name: value.name,
    text: value.text,
  }
}
